<div [formGroup]="fg">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.removePermissionsPlaybookAction.title' | labelsProvider }}
    </div>
    <mat-checkbox checked style="pointer-events: none">
      {{ 'commonActions.removePermissionsPlaybookAction.orgWideAccess' | labelsProvider }}
    </mat-checkbox>
    <br />
    <div class="disclaimer">
      {{ 'commonActions.removePermissionsPlaybookAction.disclaimer' | labelsProvider }}
    </div>
  </div>
</div>
